import React, { FC } from 'react';
import {
  TextFieldFilter,
  TextFieldFilterOperationType,
} from 'components/organisms/tasks/filters/text';
import { TextFieldFiltertoHandlebarOperatorsMap } from './hb-operators-map';
import { getFieldPathForConditionalVariable } from './utils';

export const TextFilterToText: FC<{ filter: TextFieldFilter }> = ({
  filter,
}) => {
  const { field, type } = filter;

  return (
    <>
      {`${
        TextFieldFiltertoHandlebarOperatorsMap[type] ?? type
      } ${getFieldPathForConditionalVariable(field)} ${
        type === TextFieldFilterOperationType.Contains ||
        type === TextFieldFilterOperationType.DoesNotContain
          ? `"${filter.value}"`
          : ''
      }`.trim()}
    </>
  );
};
